import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import { ReactElement, ReactNode, useId } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import DurationSegments from './DurationSegments';

import styles from './DurationInput.module.scss';

interface IDurationInputProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  label: string;
  maxHours: number;
  endAdornment?: ReactNode;
}

const DurationInput = <TFieldValues extends FieldValues>({
  control,
  name,
  label,
  maxHours,
  endAdornment,
}: IDurationInputProps<TFieldValues>): ReactElement => {
  const labelId = useId();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => (
        <FormControl
          variant="outlined"
          size="small"
          error={Boolean(error)}
          className={styles.container}
        >
          <InputLabel id={labelId} shrink>
            {label}
          </InputLabel>
          <OutlinedInput
            notched
            label={label}
            value={value ?? ''}
            inputRef={ref}
            onBlur={onBlur}
            endAdornment={endAdornment}
            inputComponent={DurationSegments}
            inputProps={{ maxHours, onValueChange: onChange, 'aria-labelledby': labelId }}
          />
          {error?.message && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default DurationInput;
